"use client";

import { Box, Button, Image, Stack, Typography } from "components";
import { withContent } from "contexts/content";
import { useMedia } from "hooks";

function PartnerSteps({ redirect }) {
  const { laptop } = useMedia();
  return (
    <Stack component="section" className="BupDivider-bottom">
      <Typography variant="h3">¿Cómo obtener el beneficio?</Typography>
      <Stack spacing={2}>
        <Typography className="Bup-subtitle" variant="span">
          Exclusivo para clientes del Banco de Chile y Edwards.
        </Typography>
        <Stack className="BupPartner-image">
          <Stack spacing={3}>
            <Image
              src="assets/bb-0.webp"
              alt="group-activity-1"
              height={270}
              width={480}
            />
            <Button
              id="BB-register-1"
              className="BupButton-wide BupButton-dark"
              color="inherit"
              onClick={() =>
                redirect.register({ params: { signUpCode: "BCH" } })
              }
              size="large"
              variant="text"
              hidden={laptop}
            >
              Acceder al beneficio
            </Button>
          </Stack>
          <Stack className="BupPartner-steps" component="ul">
            <Box component="li">
              <Typography variant="h4">1</Typography>
              <Typography variant="p">
                Completa tus datos en el formulario de registro.
              </Typography>
            </Box>
            <Box component="li">
              <Typography variant="h4">2</Typography>
              <Typography variant="p">
                ¡Todo listo! Disfruta de de los beneficios exclusivos que
                tenemos para ti.
              </Typography>
            </Box>
          </Stack>
          <Button
            id="BB-register-2"
            className="BupButton-wide BupButton-dark"
            color="inherit"
            onClick={() => redirect.register({ params: { signUpCode: "BCH" } })}
            size="large"
            variant="text"
            hidden={!laptop}
          >
            Acceder al beneficio
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default withContent(PartnerSteps);
